import { ProductTypes } from '../models';
import { useDocument } from './useDocument';

export function useProductTypes() {
  return useDocument<ProductTypes>('ProductTypes', 'product_types');
}
